export default "__VITE_ASSET__D5sYoLwB__"